package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.ccab.CCABServer
import com.neurobs.react.{StateAttribute, StateContextBase}
import org.scalajs.dom.raw.AudioContext

import scala.concurrent.ExecutionContext.Implicits.global

/**
 * @param loading Whether data for a new test transcript is currently being loaded
 * @param selection The data for the transcript currently under review
 */
case class ReviewSelectionData
(
  loading: Boolean = false,
  selection: Option[TestTranscriptReviewData] = None
)

/** Tracks what test transcript is currently being handled by the review component */
case class ReviewSelectionState
(
  data: StateAttribute[ReviewSelectionData]
)
{
  def setSelection(selection: TestTranscriptSelection)(implicit server: CCABServer, errorState: ErrorState, audioContext: AudioContext): Unit = {
    if (!data.value.loading) {
      TestTranscriptReviewData.apply(selection).res map {
        case Left(error) =>
          errorState.addError(error.description)
          data.setValue(ReviewSelectionData(false, None))
        case Right(transcriptData) =>
          data.setValue(ReviewSelectionData(false, Some(transcriptData)))
      }
      data.setValue(ReviewSelectionData(true, None))
    }
  }
}

object ReviewSelectionState extends StateContextBase[ReviewSelectionState, ReviewSelectionData] {
  override protected def defaultStateValue = ReviewSelectionData()

  override protected def makeState(a: StateAttribute[ReviewSelectionData]) = ReviewSelectionState(a)
}